import React, { Component }  from 'react';
import Gallery from "./gallery";

function App() {
  return (
    <div className="App">
      <Gallery />
    </div>
  );
}

export default App;
